// extracted by mini-css-extract-plugin
export default {"collection__wrapper":"collections_collection__wrapper__-xOcc","heading":"collections_heading__FjZUA","categories__grid":"collections_categories__grid__zUxRR"};